module.exports = __webpack_public_path__ + "img/habitos.532b33be.png";